export * from './cookie-service/cookie.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-cookie-service/index.js
// module id = 201
// module chunks = 10